import "./ProductCardPrice.scss";
import StarRating from "../StarRating/StarRating";
import commaSeparator from "../../Assets/Utils/CommaSeparator";
import "./ProductCard.scss";
import IconViewer from "../../Assets/svg/IconViewer";
import {useState, useContext, useEffect} from "react";
import trash from "../../Assets/images/trash.svg";
import {SetSaleContext} from "../pages/Pages";
import {toast} from "react-toastify";

const ProductCardPrice = (props) => {
  const [numberVisible, setNumberVisible] = useState(false);
  const [currentNum, setCurrentNum] = useState(0);
  const [currentValue, setCurrentValue] = useState(props.defaultWeight);
  const [action, setAction] = useState("");
  const [selectedamount, setSelectedamount] = useState("");
  const setSaleNum = useContext(SetSaleContext);
  const productInfo = props?.productInfo;
  const handleAddToCart = () => {
    let pros =
      localStorage.getItem("products") !== ""
        ? JSON.parse(localStorage.getItem("products"))
        : [];
    if (pros.length === 0) {
      productInfo["count"] = selectedamount;
      pros.push(productInfo);
    } else {
      const index = pros.findIndex((item) => item.id === productInfo.id);

      if (action === "delete") {
        setCurrentNum(0)
        setSelectedamount(0);
        pros = pros.filter((el) => el.id !== productInfo.id);

      } else if (index !== -1) {
        if (action === "up") {
          pros[index].count = currentNum;
        } else if (action === "down") {
          pros[index].count = currentNum;
        } else {
          pros[index].count = currentNum;
        }
      } else {
        pros.push({...productInfo, count: currentNum});
      }
    }

    localStorage.setItem("products", JSON.stringify(pros));
    setSaleNum((prevAmount) => +prevAmount + 1);
  };
  useEffect(() => {
    if (currentNum > 0) {

      handleAddToCart();
    }
  }, [currentNum, action]);

  const numHandler = (data) => {
    let tp
    if (props.productInfo.type === 1) {
      tp = 1
    } else {
      tp = +props.productInfo.defultValue
    }
    if (data === "up" && currentNum < +props.inventory) {
      setCurrentNum((prevCount) => +prevCount + tp);

      setSelectedamount((prevAmount) => +prevAmount + tp);
    } else if (data === "down" && currentNum > 0) {
      setCurrentNum((prevCount) => +prevCount - tp);

      setSelectedamount((prevAmount) => +prevAmount - tp);
    } else {
      toast.error("موجودی کافی نیست")
    }
    setAction(data);
  };

  return (
    <div className="productCardDtailsParent__">
      <div className="productCardDtails__">
        <span className="productCardMainPrice__">

          <span className="Price_">
            قیمت :{" "}
            <span
              className="price-sec"
              style={props.offer ? {textDecorationLine: "line-through"} : {}}
            >
              {commaSeparator(props.mainPrice)}
            </span>
          </span>
          {props.offer === false && " ریال"}
          {props.offer && (
            <span className="productCardOfferPrice_">
              {commaSeparator(+props.mainPrice - +props.offerPrice)} ریال
            </span>
          )}
        </span>
        <span className="productCardMainPrice__">

          <span className="Price_">
            جمع کل :{" "}
            <span
              className="price-sec">
                  {commaSeparator(Math.floor((+props.mainPrice - +props.offerPrice) * currentNum)) + " ریال "}
            </span>
          </span>

        </span>
        <span className="ProductCardscore__">
          <span className="Price_">امتیاز:</span>{" "}
          <span className="score_">{`(${props.score})`}</span>
          <span className="scoreIcons__">
            <StarRating rating={props.score}/>
          </span>
        </span>
      </div>
      {!numberVisible ? (
        <div
          className="shopIcon__"
          onClick={() => {
            numHandler("up");
            setNumberVisible(true);
          }}
        >
          <IconViewer icon={"AddBtn"}/>
        </div>
      ) : (
        <div className="box-counter">
          <button className="icon-box" id="up" onClick={() => numHandler("up")}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
            >
              <g clip-path="url(#clip0_1128_20332)">
                <path
                  d="M9 5.75H1C0.59 5.75 0.25 5.41 0.25 5C0.25 4.59 0.59 4.25 1 4.25H9C9.41 4.25 9.75 4.59 9.75 5C9.75 5.41 9.41 5.75 9 5.75Z"
                  fill="#40B2AA"
                />
                <path
                  d="M5 9.75C4.59 9.75 4.25 9.41 4.25 9V1C4.25 0.59 4.59 0.25 5 0.25C5.41 0.25 5.75 0.59 5.75 1V9C5.75 9.41 5.41 9.75 5 9.75Z"
                  fill="#40B2AA"
                />
              </g>
              <defs>
                <clipPath id="clip0_1128_20332">
                  <rect width="10" height="10" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </button>

          <input
            value={props.productInfo.type === 1 ? currentNum : currentNum.toFixed(1)}
            readOnly
          />
          <p>{props.productInfo.type === 1 ? "عدد" : "کیلوگرم"}</p>

          <button
            className="icon-box"
            id="low"

            // onClick={() => numHandler("down", item.productId)}
          >
            {currentNum > (props.productInfo.type === 1 ? 1 : props.productInfo.defultValue) ? (
              <svg
                onClick={() => numHandler("down")}
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
              >
                <path
                  d="M9 5.75H1C0.59 5.75 0.25 5.41 0.25 5C0.25 4.59 0.59 4.25 1 4.25H9C9.41 4.25 9.75 4.59 9.75 5C9.75 5.41 9.41 5.75 9 5.75Z"
                  fill="#40B2AA"
                />
              </svg>
            ) : (
              <img
                src={trash}
                onClick={() => {
                  setNumberVisible(false);
                  setAction("delete");
                }}
                alt=""
              />
            )}
          </button>
        </div>
      )}
    </div>
  );
};

export default ProductCardPrice;
